import { Component, Input } from '@angular/core';
import { AbstractPageComponent, IPageData } from 'src/app/shared/components/abstract-page/abstract-page.component';
import { IUProperty } from '../../../dynamic-module/lib/public_api';
import { IPictureData } from '../../../shared/components/picture/picture.component';

interface ILoginData extends IPageData {
  title: IUProperty<string>;
  backgroundImage: IUProperty<IPictureData>;
  fontColorPicker: IUProperty<string>;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less']
})
export class LoginComponent extends AbstractPageComponent {
  @Input() data: ILoginData;

  defaultTitle = 'Login page';

}
